import type {
  AdminPermissions,
  AgencyLevel,
  AgencyPermission,
  ContractLevel,
  ContractPermission,
  NetowrkPermission,
  NetworkLevel,
  ShiftLevel,
  ShiftPermission,
  StatisticsLevel,
  StatisticsPermission,
} from '@front/type/admin'

export const mockedShiftPermissions: Record<ShiftLevel, ShiftPermission[]> = {
  NO_ACCESS: [],
  VIEW: ['VIEW_SHIFT', 'EXPORT_SHIFT', 'DOWNLOAD_SHIFT_SUMMARY'],
  'REQUEST-': [
    'VIEW_SHIFT',
    'EXPORT_SHIFT',
    'DOWNLOAD_SHIFT_SUMMARY',
    'MODIFY_SHIFT',
    'CANCEL_SHIFT',
    'VALIDATE_SHIFT',
    'VIEW_REQUEST',
    'CREATE_REQUEST',
    'CANCEL_REQUEST',
  ],
  REQUEST: [
    'VIEW_SHIFT',
    'CREATE_SHIFT',
    'EXPORT_SHIFT',
    'DOWNLOAD_SHIFT_SUMMARY',
    'SELECT_CANDIDATE',
    'MODIFY_SHIFT',
    'CANCEL_SHIFT',
    'VALIDATE_SHIFT',
    'ASSIGN_SHIFT_POOL',
    'VIEW_REQUEST',
  ],
  CREATE: [
    'VIEW_SHIFT',
    'CREATE_SHIFT',
    'EXPORT_SHIFT',
    'DOWNLOAD_SHIFT_SUMMARY',
    'SELECT_CANDIDATE',
    'MODIFY_SHIFT',
    'CANCEL_SHIFT',
    'VALIDATE_SHIFT',
    'ASSIGN_SHIFT_POOL',
    'VIEW_REQUEST',
    'ACCEPT_REQUEST',
    'REFUSE_REQUESt',
  ],
}

export const mockedNetworkPermissions: Record<
  NetworkLevel,
  NetowrkPermission[]
> = {
  NO_ACCESS: [],
  VIEW: ['VIEW_NETWORK', 'VIEW_PROFILE'],
  EDIT: [
    'VIEW_NETWORK',
    'VIEW_PROFILE',
    'UPDATE_ORIGIN_SERVICE',
    'UPDATE_REGISTRATION_NUMBER',
    'PROCESS_SPECIALTIES',
  ],
  ACCEPT: [
    'VIEW_NETWORK',
    'VIEW_PROFILE',
    'UPDATE_ORIGIN_SERVICE',
    'UPDATE_REGISTRATION_NUMBER',
    'PROCESS_SPECIALTIES',
    'UPDATE_STATUS',
    'INVITE_TO_NETWORK',
    'REJECT_TO_NETWORK',
    'REMOVE_FROM_NETWORK',
    'ACCEPT_TO_NETWORK',
  ],
  MANAGE: [
    'VIEW_NETWORK',
    'VIEW_PROFILE',
    'UPDATE_ORIGIN_SERVICE',
    'UPDATE_REGISTRATION_NUMBER',
    'PROCESS_SPECIALTIES',
    'UPDATE_STATUS',
    'INVITE_TO_NETWORK',
    'REJECT_TO_NETWORK',
    'REMOVE_FROM_NETWORK',
    'ACCEPT_TO_NETWORK',
    'VIEW_PERSONAL_INFORMATION',
    'UPDATE_PERSONAL_INFORMATION',
  ],
}

export const mockedAgencyPermissions: Record<AgencyLevel, AgencyPermission[]> =
  {
    NO_ACCESS: [],
    REQUEST: [
      'SELECT_CANDIDATE',
      'REQUEST_AGENCY_ALERT',
      'CANCEL_AGENCY_ALERT_REQUEST',
    ],
    CREATE: [
      'SELECT_CANDIDATE',
      'ASSIGN_CANDIDATE',
      'ALERT_AGENCY',
      'CANCEL_AGENCY_ALERT',
      'ACCEPT_AGENCY_ALERT_REQUEST',
      'DECLINE_AGENCY_ALERT_REQUEST',
    ],
  }

export const mockedContractPermissions: Record<
  ContractLevel,
  ContractPermission[]
> = {
  NO_ACCESS: [],
  VIEW: ['VIEW_CONTRACT', 'DOWNLOAD_CONTRACT'],
  EDIT: [
    'VIEW_CONTRACT',
    'DOWNLOAD_CONTRACT',
    'MERGE_CONTRACT',
    'VALIDATE_CONTRACT',
    'CANCEL_CONTRACT',
  ],
  SIGN: [
    'VIEW_CONTRACT',
    'DOWNLOAD_CONTRACT',
    'MERGE_CONTRACT',
    'VALIDATE_CONTRACT',
    'CANCEL_CONTRACT',
    'SIGN_CONTRACT',
  ],
}

export const mockedStatisticsPermissions: Record<
  StatisticsLevel,
  StatisticsPermission[]
> = {
  NO_ACCESS: [],
  VIEW: ['VIEW_STATISTICS'],
}

export const mockedAdminPermissions: AdminPermissions = {
  shift: {
    level: 'NO_ACCESS',
    permissions: [],
  },
  agency: {
    level: 'NO_ACCESS',
    permissions: [],
  },
  contract: {
    level: 'NO_ACCESS',
    permissions: [],
  },
  internalNetwork: {
    level: 'NO_ACCESS',
    permissions: [],
  },
  externalNetwork: {
    level: 'NO_ACCESS',
    permissions: [],
  },
  statistics: {
    level: 'NO_ACCESS',
    permissions: [],
  },
}
